






import Vue from 'vue';

export default Vue.extend({
  name: "FleaMarketMain2d",
  data: () => {
    return {};
  },
});
